import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Redirect, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useApplicationState, usePromisedLazyQuery } from "../../../state/store/customHooks";
import { ONBOARDING_STEPS, URI_PATHS, GQL_ERROR } from "../../../constants";

// Actions
import { initiateStepsState } from "../../../state/actions";

/* Components */
import Header from "../../common/Header";
import ResumeApplicationV2 from "../resumeApplication/ResumeApplicationV2";
import VerifyPhoneV2 from "../verifyPhone/VerifyPhoneV2";
import AddressV2 from "../address/AddressV2";
import VerifyIdentityV2 from "../verifyIdentity/VerifyIdentityV2";
import LinkBankV2 from "../linkBank/LinkBankV2";
import ConfirmV2 from "../confirm/ConfirmV2";
import DecisionV2 from "../decision/DecisionV2";
import Error from "../errors/Error";
import StepperV2 from "./StepperV2";

// GQL
import withQuery from "../wrappers/gql/withQuery";
import { GET_APPLICATION_INFO, GET_APP_INFO_AND_ACCOUNTS } from "../../../api/gql";
import Loading from "../../common/Loading";

// flipped shows url to component
// step component names are the same as the step name;
const URI_PATHS_FLIPPED = Object.fromEntries(Object.entries(URI_PATHS).map(([k, v]) => [v, k]));

const OnboardingV2 = ({ data: initialOnboardingData }) => {
  const dispatch = useDispatch();

  const { resumeAtStep, status } = initialOnboardingData.getApplicationStep; // stale actually
  const currentStep = ONBOARDING_STEPS[resumeAtStep];
  const { pathname } = useLocation()
  const currentStepFromState = useApplicationState("currentStep");
  const stepOrder = useApplicationState("stepOrder");
  const [ getBankAccounts, { data: BankAccountsData, loading: BankAccountsDataLoading }] = usePromisedLazyQuery(GET_APP_INFO_AND_ACCOUNTS);
  const defaultAllow = currentStep === ONBOARDING_STEPS.Decision && URI_PATHS_FLIPPED[pathname];

  useEffect(() => {
    if (defaultAllow) { dispatch(getBankAccounts) }
    dispatch(initiateStepsState(currentStep));
  }, []);

  if (BankAccountsDataLoading) {
    return <Loading/>
  }

  // note: ONBOARDING_STEPS.Decision // CONFIRM are the same step name..
  // note: defaultAllow means user has atleast gone to confirm step...
  if (defaultAllow && BankAccountsData) {
    const { getBankAccounts } = BankAccountsData;
    if (getBankAccounts.unlinkedAccountsFound) return <Redirect to={URI_PATHS.RELINK_BANK}/>
  }

  if (stepOrder && pathname !== URI_PATHS.RESUME_APPLICATION && currentStepFromState == currentStep) {
    const currentStepIndex = stepOrder.findIndex((step) => currentStep == step);
    const stepFromPathIndex = stepOrder.findIndex((step) => step == URI_PATHS_FLIPPED[pathname]);
    
    if (!defaultAllow && (stepFromPathIndex === -1 || stepFromPathIndex > currentStepIndex)) {
       return <Redirect to={URI_PATHS.RESUME_APPLICATION} /> 
    }
  }

  // This logic should really be wrapped within withQuery or have BE throw a 500 error
  // instead of catching it and returning data that says "ERROR"
  if(status === GQL_ERROR)
    return <Error />;

  // TODO: Create error page for route that doesn't exist OR... go back to /resumeapplication?
  return (
    <div className="stepContainer">
      <Header />
      <div className="innerStepContainer">
        <StepperV2 />
        <TransitionGroup>
          <CSSTransition classNames="onboardingAnimate" key={currentStep} timeout={500}>
            <div className="onboardingAnimate-wrapper">
              <Route exact path={URI_PATHS.RESUME_APPLICATION} component={ResumeApplicationV2}/>
              <Route exact path={URI_PATHS.VERIFY_PHONE} component={VerifyPhoneV2}/>
              <Route exact path={URI_PATHS.ADDRESS} component={AddressV2}/>
              <Route exact path={URI_PATHS.VERIFY_IDENTITY} component={VerifyIdentityV2}/>
              <Route exact path={URI_PATHS.LINK_BANK} component={LinkBankV2}/>
              <Route exact path={URI_PATHS.CONFIRM} component={ConfirmV2}/>
              <Route exact path={URI_PATHS.DECISION} component={DecisionV2}/>
            </div>
          </CSSTransition>
        </TransitionGroup>
      </div>
    </div>
  );
};

export default withQuery(GET_APPLICATION_INFO)(OnboardingV2);